import { LocalizeContextProps } from 'react-localize-redux';
import * as React from 'react';
import { setLanguagePreference } from '../../utils/language-preference';
import './LanguageToggle.scss';

export interface LanguageToggleProps extends LocalizeContextProps {
  enabledLanguages: string[];
  brandColor?: string;
}

export const LanguageToggleComponent: React.FunctionComponent<LanguageToggleProps> = ({
  enabledLanguages,
  brandColor,
  activeLanguage,
  setActiveLanguage,
}) => {
  const handleSelect = (language: string) => () => {
    if (activeLanguage && language === activeLanguage.code) return;
    setActiveLanguage(language);
    setLanguagePreference(language);
  };

  return (
    <div className="language-toggle-component" role="group" aria-label="Language">
      {enabledLanguages.map((language, index) => {
        const isActive = !!activeLanguage && activeLanguage.code === language;
        return (
          <React.Fragment key={language}>
            <button
              type="button"
              className={`language-toggle-component__option ${
                isActive ? 'language-toggle-component__option--active' : ''
              }`}
              style={isActive && brandColor ? { color: brandColor } : undefined}
              aria-pressed={isActive}
              onClick={handleSelect(language)}
            >
              {language.toUpperCase()}
            </button>
            {index < enabledLanguages.length - 1 && (
              <span className="language-toggle-component__separator" aria-hidden="true">
                |
              </span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
